import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvDescriptor, EnvLoader } from '../Environment/EnvLoader';

// create structure for string payment way "edenred"|"cb"|"wallet"
export type PaymentWay = 'EDENRED' | 'CB' | 'WALLET';

@Injectable({
  providedIn: 'root',
})
export class PaymentWallService {
  private http = inject(HttpClient);

  env: EnvDescriptor | undefined;

  constructor() {
    if (!(globalThis as any).env) {
      (globalThis as any).env = EnvLoader.load();
    }

    this.env = (globalThis as any).env;
  }

  /**
   * Retrieves available payment methods for a specific enterprise and customer
   * @param enterpriseId - The ID of the enterprise
   * @param cstId - The customer ID
   * @returns Promise resolving to array of enabled payment methods (EDENRED, CB, WALLET)
   */
  public getEnabledPayments(
    enterpriseId: number,
    cstId: number
  ): Promise<PaymentWay[]> {
    return new Promise((res) => {
      this.http
        .get(
          `${this.env?.boGestionUrl}/api/orders/list_payment_way/${enterpriseId}?cst_id=${cstId}`
        )
        .subscribe((data) => {
          res(((data as any).payments as PaymentWay[]) || []);
        });
    });
  }
}
